import React, { useEffect, useState } from "react";

const AnimatedText = ({ text }) => {
  const [characters, setCharacters] = useState([]);

  useEffect(() => {
    setCharacters(text.split(""));
  }, [text]);

  return (
    <p className="md:text-8xl text-7xl stroke-text">
      {characters.map((char, index) => (
        <span key={index} style={{ "--char-index": index }}>
          {char}
        </span>
      ))}
    </p>
  );
};

export default AnimatedText;
